import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import get from "lodash/get";

import { Field, FieldError, FieldLabel } from "@/components/ui/field";
import ColorPicker from "components/ColorPicker";
import ListInput from "components/BaseForm/fields/ListInput";
import { choicesForValues } from "routes/custom_tables/choiceHelpers";
import ChoiceChip from "routes/custom_tables/grid/cells/ChoiceChip";

// ListInput edits the choice values; each chip carries its own color picker.
const ChoiceListField = ({ name, label, placeholder }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const choices = field.value ?? [];
        const colorOf = value => choices.find(c => c.value === value).color;
        const setColor = (value, color) =>
          field.onChange(
            choices.map(c => (c.value === value ? { ...c, color } : c))
          );
        return (
          <Field data-invalid={error ? true : undefined}>
            {label && <FieldLabel htmlFor={name}>{label}</FieldLabel>}
            <ListInput
              id={name}
              value={choices.map(c => c.value)}
              onChange={values =>
                field.onChange(choicesForValues(choices, values))
              }
              error={!!error}
              placeholder={placeholder}
              renderChip={(value, removeButton) => (
                <span className="tw:inline-flex tw:items-center">
                  <ColorPicker
                    small
                    color={colorOf(value)}
                    setColor={color => setColor(value, color)}
                    ariaLabel={`Choose color for ${value}`}
                  >
                    <ChoiceChip label={value} color={colorOf(value)} />
                  </ColorPicker>
                  {removeButton}
                </span>
              )}
            />
            <FieldError>{error?.message}</FieldError>
          </Field>
        );
      }}
    />
  );
};

ChoiceListField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  placeholder: PropTypes.string,
};

export default ChoiceListField;
